export { default, createFilterOptions } from './useAutocomplete';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/useAutocomplete/index.js
// module id = 1823
// module chunks = 0